import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { JobComponent } from './job/job.component';
import { PerformanceComponent } from './performance/performance.component';
import { DesignComponent } from './design/design.component';
import { ManagementComponent } from './management/management.component';
import { ReferencesComponent } from './references/references.component';
// import { RefComponent } from './ref/ref.component';
import { TeamComponent } from './team/team.component';
import { NewsComponent } from './news/news.component';
import { SingleNewsComponent } from './single-news/single-news.component';
import { NewsLinksComponent } from './news-links/news-links.component';
import { ContactComponent } from './contact/contact.component';
import { LegalsComponent } from './legals/legals.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'metier', component: JobComponent,
    children: [
      { path: '', redirectTo: 'performance', pathMatch: 'full' },
      { path: 'performance', component: PerformanceComponent },
      { path: 'design', component: DesignComponent },
      { path: 'management', component: ManagementComponent }
    ]
  },
  { path: 'references', component: ReferencesComponent },
  { path: 'references/:slug', component: ReferencesComponent },
  { path: 'equipe', component: TeamComponent },
  { path: 'actualites', component: NewsComponent },
  { path: 'actualites/:slug', component: NewsLinksComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'mentions-legales', component: LegalsComponent },
  { path: '**', redirectTo: '/', pathMatch: 'full' }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts